import axios from 'axios';

export function postRequestHire(hireRequest) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/hires',
        data: hireRequest,
        params: {
            wrapper: hireRequest.clientVessel ? 'email_wrapper' : undefined,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getHiresList(filter) {
    return axios({
        method: 'post',
        url: '/api/v2/adminPanel/hires/search',
        withCredentials: true,
        data: filter,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function updateHireIdeas({ update = [], toDelete = [] }) {
    return axios({
        method: 'post',
        url: '/api/v2/adminPanel/hires/update',
        data: { update, toDelete },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response);
}

/**
 * @param {'csv' | 'json'} extention 
 * @param {*} filter
 * @param {Record<string, 1 | -1>} select 
 * 
 */
export function exportHireIdeas(extention, filter, select) {
    return axios({
        method: 'post',
        url: `/api/v2/adminPanel/hires/export?q=${extention}`,
        withCredentials: true,
        data: { filter, select },
        // responseType: 'blob',
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/hires/requests.js